export default "__VITE_ASSET__BprDVC2I__"